<ion-grid class="ion-no-padding">
  <ion-row>
    <ion-col
      class="ion-no-padding"
      size="12"
      size-xs="12"
      size-md="12"
      size-lg="12"
    >
      <ion-row>
        <ion-col class="ion-no-padding">
          <ion-item lines="none" class="ion-no-padding">
            <ion-label
              class="panel-header-text ion-padding-bottom"
              color="dark"
            >
              {{ 'devices_title' | translate }}
            </ion-label>
          </ion-item>
        </ion-col>
      </ion-row>
      @if (isDisabled()) {
        <ion-row>
          <ion-col>
            <admin-core-lib-installation-no-access>
            </admin-core-lib-installation-no-access>
          </ion-col>
        </ion-row>
      } @else if (!isDisabled() && isCtdLimitReached()) {
        <ion-row>
          <ion-col>
            <admin-core-lib-installation-ctd-limit>
            </admin-core-lib-installation-ctd-limit>
          </ion-col>
        </ion-row>
      } @else {
        <ion-row>
          <ion-col>
            <ion-item class="ion-no-padding ion-margin-top">
              <ion-label class="ion-padding-end ion-margin-end"
                ><b>{{ 'device_serialNumber' | translate }}</b>
              </ion-label>
              <ion-label class="ion-padding-start ion-margin-start"
                ><b>{{ 'device_type' | translate }}</b>
              </ion-label>
              <ion-label class="ion-text-end"></ion-label>
              <ion-label class="menu ion-text-end"></ion-label>
            </ion-item>
          </ion-col>
        </ion-row>
      }

      <ion-row>
        <ion-col class="ion-no-padding devices-list">
          @for (parentDevice of devices(); track parentDevice.id) {
            <div>
              <!-- ubie device -->
              @if (parentDevice.type?.toLowerCase() === 'ubie') {
                <ion-item lines="none" class="ion-no-padding">
                  <ion-img src="icon/ubie.png" class="ubie-icon"></ion-img>
                  <ion-label class="ion-padding-start">
                    {{ parentDevice.serialNumber }}
                  </ion-label>
                  <ion-label class="ion-padding-start">{{
                    parentDevice.type
                  }}</ion-label>

                  @if (parentDevice.online) {
                    <shared-status-tag
                      slot="end"
                      color="success"
                      [tag]="'device_isOnline' | translate"
                    ></shared-status-tag>
                  } @else {
                    <shared-status-tag
                      slot="end"
                      color="danger"
                      [tag]="'device_isOffline' | translate"
                    ></shared-status-tag>
                  }

                  @if (parentDevice.ownerIdConfirmed === false) {
                    <ion-label
                      class="menu ion-text-end"
                      (click)="presentPopover($event, parentDevice)"
                    >
                      <ion-icon
                        name="caret-down-outline"
                        class="border-with-radius cursor-pointer icon-padding"
                      ></ion-icon>
                    </ion-label>
                  } @else {
                    <ion-label class="menu ion-text-end"> </ion-label>
                  }
                </ion-item>
              }

              <!-- network devices -->
              @for (
                networkDevice of parentDevice.networkDevices;
                track networkDevice.id ?? networkDevice.serialNumber
              ) {
                <ion-item
                  lines="none"
                  [class.clickable-item]="
                    networkDevice.type?.toLowerCase() === 'qbus' &&
                    parentDevice.type?.toLowerCase() === 'ubie'
                  "
                  [class.ion-no-padding]="
                    parentDevice.type?.toLowerCase() === 'ubieslice'
                  "
                  (click)="
                    networkDevice.type?.toLowerCase() === 'qbus' &&
                      parentDevice.type?.toLowerCase() === 'ubie' &&
                      onClickItem(networkDevice.id ?? 0)
                  "
                >
                  <ion-img
                    src="icon/{{ networkDevice.type | lowercase }}.png"
                    class="ubie-icon"
                  ></ion-img>
                  <ion-label class="ion-padding-start">
                    {{ networkDevice.name }}
                  </ion-label>
                  <ion-label class="">{{ networkDevice.type }}</ion-label>

                  @if (!parentDevice.online) {
                    <shared-status-tag
                      slot="end"
                      color="danger"
                      [tag]="'device_isOffline' | translate"
                    ></shared-status-tag>
                  } @else {
                    <ng-container>
                      @if (
                        !networkDevice.online && !networkDevice.connectable
                      ) {
                        <shared-status-tag
                          slot="end"
                          color="medium"
                          [tag]="'device_isInactive' | translate"
                        ></shared-status-tag>
                      } @else if (
                        networkDevice.online && networkDevice.connectable
                      ) {
                        <shared-status-tag
                          slot="end"
                          color="success"
                          [tag]="'device_isOnline' | translate"
                        ></shared-status-tag>
                      } @else if (
                        !networkDevice.online && networkDevice.connectable
                      ) {
                        <shared-status-tag
                          slot="end"
                          color="danger"
                          [tag]="'device_isOffline' | translate"
                        ></shared-status-tag>
                      }
                    </ng-container>
                  }

                  <!-- activate controller -->
                  @if (
                    !isDisabled() &&
                    networkDevice.type?.toLowerCase() === 'qbus' &&
                    parentDevice.online &&
                    !networkDevice.connectable &&
                    !networkDevice.online
                  ) {
                    <ion-button
                      fill="clear"
                      size="small"
                      class="menu ion-text-end activate-button"
                      (click)="
                        $event.stopPropagation();
                        openActivateModal(parentDevice, networkDevice)
                      "
                    >
                      {{ 'device_activate' | translate }}
                    </ion-button>
                  } @else {
                    <ion-label class="menu ion-text-end"> </ion-label>
                  }
                </ion-item>
              }
            </div>
          }
        </ion-col>
      </ion-row>
    </ion-col>
  </ion-row>
</ion-grid>
